import React, { useRef, Fragment } from "react";
import { getMathJaxNode } from "../../mathjax/MathJax";

const ResultList = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const changedDataCount = props.data.filter( ( v, i ) => prevData.current[ i ] !== v ).length;

  const MathJaxNode = getMathJaxNode( props.type );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = props.data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <Fragment>
      <td><MathJaxNode onRender={ renderMathJax }>{ props.data[ 0 ] || '' }</MathJaxNode></td>
      <td className="td_box">
        <MathJaxNode onRender={ renderMathJax }>{ props.data[ 1 ] || '' }</MathJaxNode>
        <div className="num">{ props.index + 1 }</div>
      </td>
    </Fragment>
  );

};

export default ResultList;
